











import { Ref, Prop, Vue, Component } from "vue-property-decorator";

// Model Class
import { UIModel } from "./../../UIModel";

@Component({
	components: {},
})
export default class App extends Vue {
    // Props
    @Prop({ required: true }) public model!: UIModel;
    
}
